import dynamic from 'next/dynamic';
import StepByStepAuthProvider from '~/client/components/Auth/Authenticate/AuthSteps/context/StepByStepAuthProvider';
import CaptchaProvider from '~/client/shared/Providers/CaptchaProvider';
import PopoverContainer from './styles/PopoverContainer';
import usePopover from './usePopover';

const AuthenticatePopover = dynamic(() => import('./AuthenticatePopover'));
type Props = {
  module?: 'login' | 'signup' | 'socials';
  onClose: () => void;
  positionRight?: boolean;
};
const Popover: FC<Props> = ({ module, onClose, positionRight }) => {
  const { showLogin, isRegister, elementRef, containerWidth } = usePopover({
    onClose,
    module,
  });

  return (
    <CaptchaProvider>
      <StepByStepAuthProvider>
        <PopoverContainer
          ref={elementRef}
          isLogin={showLogin}
          positionRight={positionRight}
          width={containerWidth}
        >
          <AuthenticatePopover isRegister={isRegister} />
        </PopoverContainer>
      </StepByStepAuthProvider>
    </CaptchaProvider>
  );
};

export default Popover;
